export default __webpack_public_path__ + "img/redo.c457135.svg";